import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/shareable-lists/$slug')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/collection/$slug', params: { slug: params.slug } })
  },
})
